import { useTranslation } from "react-i18next";
import CompareStripedRows from "./CompareStripedRows";
import { V1Clinic } from "../../types/v1_schemas";
import { getLookupOptions } from "../../types/lookup";

function MentalHealthServicesTable({
  providerA,
  providerB,
}: {
  providerA: V1Clinic;
  providerB: V1Clinic;
}) {
  const { t } = useTranslation();

  if (!providerA.clinicServicesProvideds?.filter(f => 
    f.serviceCategoryText === t("mentalHealthServices")) 
    && !providerB.clinicServicesProvideds?.filter(f => 
      f.serviceCategoryText === t("mentalHealthServices"))) {
    return <></>;
  }

  const rowData = getLookupOptions("servicesProvided").filter((x) => x.description === "1500102").map((service) => {
    const a = !!providerA.clinicServicesProvideds?.filter(f => 
      f.serviceCategoryText === t("mentalHealthServices") 
      && t(f.serviceProvidedText!) === t(service.translate)
    )[0];

    const b = !!providerB.clinicServicesProvideds?.filter(f => 
      f.serviceCategoryText === t("mentalHealthServices") 
      && t(f.serviceProvidedText!) === t(service.translate)
    )[0];

    return {
      label: t(service.translate),
      compareA: a,
      compareB: b
    };
  });

  return (
    <CompareStripedRows rows={rowData} title={t("mentalHealthServices")} />
  );
}

export default MentalHealthServicesTable;
